import React from 'react';

const Header = function() {
    return <div className="wrapper-header">
        <div className="header view pb-10 pt-10">
            <h1>Subject Line Assistant</h1>
            <div className="logo">
                <a href="https://github.com/xomrau">
                    <img src="https://user-images.githubusercontent.com/22007153/87010799-71a01700-c20a-11ea-883c-11efdf0eac39.png" alt="github logo"/>
                </a>
            </div>
        </div>
    </div>
}

export default Header;